import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import * as React from "react";

export default function AlertDialog({
  title,
  description,
  handleClose,
  open,
  onAgree,
  isLoading,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {isLoading ? "" : <Button onClick={handleClose}>Disagree</Button>}
          {isLoading ? "" : <Button onClick={onAgree}>Agree</Button>}
        </DialogActions>
        {isLoading ? <p style={{ padding: "10px" }}>LOADING...</p> : ""}
      </Dialog>
    </div>
  );
}
